import type { GraphicPromoState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/graphicPromo';

export const INITIAL_STATE: GraphicPromoState = {
  byId: {},
};
